// extracted by mini-css-extract-plugin
export default {"Guide":"Privacy_Guide__vOds4","Privacy":"Privacy_Privacy__XLIFP","Refund":"Privacy_Refund__do++k","Tos":"Privacy_Tos__xPbL4","scrollBox":"Privacy_scrollBox__eATdb"};